import { useState } from 'react';

import {
  Card,
  DifficultyBadge,
  IconButton,
  List,
  ListSkeleton,
  OffsetPagination,
} from '@opositandopn/ui';
import { IoArrowForwardCircleOutline } from 'react-icons/io5';

import TrainingImg from '../../../../assets/images/087e74c4-0129-4b6b-b1e4-de49df4dfcae.webp';
import { BaseComponentProps } from '../../../../types/base-component.types';
import {
  TrainingPlanPreviewViewModel,
  useGetTrainingPlans,
} from '../../api/usePhysicalTests';

const fromTime = new Date(
  new Date().setFullYear(new Date().getFullYear() - 10),
);

type ContainerProps = BaseComponentProps & {
  onSelected?: (trainingPlan: TrainingPlanPreviewViewModel) => void;
};

function TrainingPlanList({
  className,
  onSelected,
  testId = 'ui-training-plan-list',
}: ContainerProps) {
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 20 });

  const { data: response, isLoading } = useGetTrainingPlans({
    fromTime,
    pageNumber: pagination.pageNumber,
    pageSize: pagination.pageSize,
    sort: '-createdAt',
  });

  return (
    <Card
      title="Entrenamientos"
      className={className}
      image={TrainingImg}
      testId={testId}
    >
      {isLoading || !response ? (
        <ListSkeleton items={pagination.pageSize} />
      ) : (
        <>
          <List
            items={response.items.map((item) => ({
              text:
                item.name.length > 120
                  ? item.name.substring(0, 120) + '…'
                  : item.name,
              info: item.name,
              icon: (
                <>
                  <DifficultyBadge
                    difficulty={item.difficultyLevel}
                    style={{ marginRight: '8px' }}
                  />
                  {onSelected && (
                    <IconButton
                      size="sm"
                      icon={<IoArrowForwardCircleOutline />}
                      onClick={() => {
                        onSelected(item);
                      }}
                    />
                  )}
                </>
              ),
            }))}
          />
          <OffsetPagination
            pageNumber={pagination.pageNumber}
            pageSize={pagination.pageSize}
            totalRecords={response.totalItems}
            onPageChange={(pageNumber: number) => {
              setPagination({ ...pagination, pageNumber });
            }}
            pageNeighbours={2}
          />
        </>
      )}
    </Card>
  );
}

export { TrainingPlanList };
